import React, { useState, useContext, useEffect, memo } from 'react';
import { useFormik } from 'formik';
import Button from '../../bootstrap/Button';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Label from '../../bootstrap/forms/Label';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';

import UserHistory from '../../../database/wrappers/userHistory';
import { DefaultContext } from '../../../contexts/default';
import PreAlert from '../../../helpers/utils/preAlert';
import masks, { unmask } from '../../../helpers/utils/masks';
import StoreProductDB from '../../../database/wrappers/storeProduct';

const validate = (values) => {
  const errors = {};

  const value = Number(unmask(values.price))
  if (!values.price || isNaN(value) || value === 0) {
    errors.price = 'Informe um número válido';
  }

  return errors;
}

const ModalRegisterStoreProducts = ({ open, setIsOpen, setIsClose, productSelected }) => {

  const { establishment, store, onShowAlert, user } = useContext(DefaultContext)

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!open) return formik.resetForm();
    if (productSelected) {
      const { active, price, fiscal_data } = productSelected;

      formik.setValues({
        price: unmask(String(price)),
        active: active ? 'ativo' : 'inativo',
        fiscal_data_bar_code: fiscal_data?.bar_code ?? '',
        fiscal_data_cClassTrib: fiscal_data?.cClassTrib ?? '',
        fiscal_data_cst_cbs_ibs: fiscal_data?.cst_cbs_ibs ?? '',
        fiscal_data_percentualReducao: fiscal_data?.percentualReducao ?? '',
        fiscal_data_ncm: fiscal_data?.ncm ?? null,
        fiscal_data_cst: fiscal_data?.cst ?? null,
        fiscal_data_csosn: fiscal_data?.csosn ?? null,
        fiscal_data_cest: fiscal_data?.cest ?? null,
        fiscal_data_cfop: fiscal_data?.cfop ?? null,
        fiscal_data_tributary_situation: fiscal_data?.tributary_situation ?? null,
        fiscal_data_aliq_icms: fiscal_data?.aliq_icms ?? null,
        fiscal_data_pis: fiscal_data?.pis ?? '',
        fiscal_data_cofins: fiscal_data?.cofins ?? '',
        fiscal_data_cBenef: fiscal_data?.cBenef ?? '',
      });
    }
  }, [productSelected, open])

  const formik = useFormik({
    initialValues: {
      active: '',
      price: '',
      fiscal_data_bar_code: '',
      fiscal_data_ncm: '',
      fiscal_data_cst: '',
      fiscal_data_csosn: '',
      fiscal_data_cest: '',
      fiscal_data_cfop: '',
      fiscal_data_aliq_icms: '',
      fiscal_data_tributary_situation: '',
      fiscal_data_pis: '',
      fiscal_data_cofins: '',
      fiscal_data_cBenef: '',
      fiscal_data_cClassTrib: '',
      fiscal_data_cst_cbs_ibs: '',
      fiscal_data_percentualReducao: '',
    },
    validate,
    onSubmit: values => {
      const { active, price, fiscal_data_bar_code,
        fiscal_data_ncm,
        fiscal_data_cst,
        fiscal_data_csosn,
        fiscal_data_cest,
        fiscal_data_cfop,
        fiscal_data_aliq_icms,
        fiscal_data_percentualReducao,
        fiscal_data_tributary_situation, fiscal_data_pis, fiscal_data_cofins, fiscal_data_cBenef, fiscal_data_cClassTrib,
        fiscal_data_cst_cbs_ibs, } = values;

      const fiscal_data = {
        bar_code: fiscal_data_bar_code ?? '',
        ncm: fiscal_data_ncm,
        cst: fiscal_data_cst,
        csosn: fiscal_data_csosn,
        cest: fiscal_data_cest,
        cfop: fiscal_data_cfop,
        aliq_icms: String(fiscal_data_aliq_icms ?? '').replace(',', '.'),
        tributary_situation: fiscal_data_tributary_situation,
        pis: fiscal_data_pis,
        cofins: fiscal_data_cofins,
        cBenef: fiscal_data_cBenef ?? '',
        cst_cbs_ibs: fiscal_data_cst_cbs_ibs ?? '',
        cClassTrib: fiscal_data_cClassTrib ?? '',
        percentualReducao: fiscal_data_percentualReducao ?? '',
      };

      const data = {
        active: active === 'ativo',
        price: Number(unmask(price)),
        fiscal_data,

      }

      const onSuccess = () => {
        onShowAlert(PreAlert.success('Registro cadastrado com sucesso'))
        setIsClose();
      }
      const onSuccessUpdate = () => {
        onShowAlert(PreAlert.success('Registro atualizado com sucesso'))
        setIsClose();
      }
      const onError = (error) => {
        console.error(error);
        onShowAlert(PreAlert.error('Falhou ao cadastrar o registro'))
      }

      setIsLoading(true)
      new StoreProductDB(establishment.id, store.id).get(productSelected.id)
        .then((product) => {
          if (product) {
            new StoreProductDB(establishment.id, store.id)
              .update(productSelected.id, data)
              .then(() => {
                onSuccessUpdate();
                new UserHistory(establishment.id, user, "o Produto", store.name)
                  .update(productSelected.id, { data, selected: productSelected, active: data.active })
                  .finally(() => { })
              })
              .catch(onError)
              .finally(() => { })
          }
        })
        .catch(() => {
          new StoreProductDB(establishment.id, store.id)
            .define(productSelected.id, data)
            .then(() => {
              onSuccess();
              new UserHistory(establishment.id, user, "o Produto", store.name)
                .update(productSelected.id, { data, selected: productSelected, active: data.active })
                .finally(() => { })
            })
            .catch(onError)
            .finally(() => { })
        })
        .finally(() => setIsLoading(false))
    },
  })

  return (
    <Modal
      id={'modal-register-totem'}
      titleId={'Cadastro de Totem'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl' 
      isAnimation={true}
      onSubmit={formik.handleSubmit}
    >
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id="register-totem">{productSelected ? 'Atualização de Produto' : 'Cadastro de Preço do Produto'}</ModalTitle>
      </ModalHeader>
      <ModalBody className='p-4'>
        <div className='d-flex flex-column align-items-center col-md-12'>
          <img src={productSelected?.image_url} height={100} width={100} />
          <h3 style={{ marginTop: 20, marginBottom: 20 }}>{productSelected?.name}</h3>
        </div>

        <div className="row g-4">
          <FormGroup
            id='price' label='Preço' className='col-md-4'
          >
            <Input
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={masks.money(formik.values.price)}
              isValid={formik.isValid}
              isTouched={formik.touched.price}
              invalidFeedback={formik.errors.price}
              validFeedback='Assim está bom!'
              placeholder='R$ 0,00'
            />
          </FormGroup>

          <FormGroup id='fiscal_data_bar_code' label='Código de barras' className='col-md-4'>
            <Input
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.fiscal_data_bar_code}
              isValid={formik.isValid}
              isTouched={formik.touched.fiscal_data_bar_code}
              invalidFeedback={formik.errors.fiscal_data_bar_code}
              validFeedback='Assim está bom!'
              placeholder='Ex: 7891234567890'
              inputMode='numeric'
            />
          </FormGroup>

          <FormGroup className='col-md-4'>
            <Label>Status</Label>
            <ChecksGroup
              isValid={formik.isValid}
              isTouched={formik.touched.active}
              invalidFeedback={formik.errors.active}
            >
              <Checks
                type="radio"
                id="active"
                label="Ativo"
                name="active"
                value="ativo"
                onChange={formik.handleChange}
                checked={formik.values.active}
                isInline
              />
              <Checks
                type="radio"
                id="active2"
                label="Inativo"
                name="active"
                value="inativo"
                onChange={formik.handleChange}
                checked={formik.values.active}
                isInline
              />
            </ChecksGroup>
          </FormGroup>
        </div>

        <div className='d-flex justify-content-end gap-2 mt-4'>
          <Button color='danger' onClick={setIsClose} type='button'>
            Cancelar
          </Button>
          {isLoading ? (
            <Button color='success' type='button' isDisable>
              <Spinner color='light' inButton isGrow isSmall size={10} tag='span'>
                Carregando...
              </Spinner>
              Salvando...
            </Button>
          ) : (
            <Button color='success' onClick={formik.handleSubmit} type='button'>
              Salvar
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default memo(ModalRegisterStoreProducts);
